module.exports = "/_next/static/images/cnn-e85ec3c42aaa628a1bf42dac93f297b8.svg";